import RequestCancelBtn from '@/components/CancelRequestBtn/cancelRequestBtn';
import {
  NBtn,
  NIcon,
  NContainer,
  NTextField,
  NTextarea,
  NStepper,
  NStepperHeader,
  NStepperFooter,
  NSelect,
  NGrid,
  NGridItem,
  NCardPanel,
  NLabelAndValue,
  NDialog,
  NDialogFooter,
  NDialogHeader,
  NEmptyPlaceholder,
  NDivider,
  NAlert,
  NRadioGroup,
  NRadio,
  NRadioSelect,
  NCheckboxGroup,
  NAttachmentField,
  NCheckbox,
  NTabs,
  NTab,
  NTabsItems,
  NTabItem,
  NTable,
  NChip,
  NInput,
  NPaginationLayout,
  NDatePicker,
  NCard,
  NSvg,
} from '@moj/vue3-mui';
import type { App as Application } from 'vue';

export const registerGlobalComponents = (app: Application) => {
  app
    .component('NBtn', NBtn)
    .component('NIcon', NIcon)
    .component('NGrid', NGrid)
    .component('NAlert', NAlert)
    .component('NRadio', NRadio)
    .component('NRadioSelect', NRadioSelect)
    .component('NSelect', NSelect)
    .component('NDialog', NDialog)
    .component('NDivider', NDivider)
    .component('NStepper', NStepper)
    .component('NCheckbox', NCheckbox)
    .component('NGridItem', NGridItem)
    .component('NContainer', NContainer)
    .component('NTextField', NTextField)
    .component('NTextarea', NTextarea)
    .component('NCardPanel', NCardPanel)
    .component('NRadioGroup', NRadioGroup)
    .component('NDialogHeader', NDialogHeader)
    .component('NDialogFooter', NDialogFooter)
    .component('NStepperHeader', NStepperHeader)
    .component('NStepperFooter', NStepperFooter)
    .component('NLabelAndValue', NLabelAndValue)
    .component('NCheckboxGroup', NCheckboxGroup)
    .component('NAttachmentField', NAttachmentField)
    .component('NEmptyPlaceholder', NEmptyPlaceholder)
    .component('NTabs', NTabs)
    .component('NTab', NTab)
    .component('NTabsItems', NTabsItems)
    .component('NTabItem', NTabItem)
    .component('NTable', NTable)
    .component('NChip', NChip)
    .component('NInput', NInput)
    .component('NPaginationLayout', NPaginationLayout)
    .component('NDatePicker', NDatePicker)
    .component('NCard', NCard)
    .component('NSvg', NSvg)
    // Non mui related
    .component('RequestCancelBtn', RequestCancelBtn);
};